import { StoreProfile, CheckoutStoreSelector, CheckoutSelectors, CheckoutService, CustomerAddress, ConsignmentsRequestBody } from '@bigcommerce/checkout-sdk'
import { storage, constants, util } from '../utils'
import store from '../store'
import { setCheckoutShippingIsComplete, setGlobalIsB3User, setCompanyBasicInfo, setBasicAddressInfo, setGlobalIsPending, setCheckoutSettings } from '../store/actions'
import { mapCustomFormFieldsFromFormValues } from '../../formFields';
import Swal from 'sweetalert2'
import { tips } from '../locales'
import { routes, permissions } from '../config'
import { Country, getCompanyBasicInfo, getStoreCheckoutSettings } from '../request/apis'
import axios from 'axios'

import b3Login from './b3Login'
import addresses from '../addresses'
import extrasFiles from '../extrasFiles';

import { B3SetField } from '../utils/util'

import address from '../addresses'

import request from '../request'

import { setAddressExtrasFiles } from '../extrasFiles/address'

const getQuoteData = async(data: CheckoutStoreSelector, quoteId: string, service: CheckoutService) => {

    const { global: { checkoutShippingIsComplete } } = store.getState()
    if (checkoutShippingIsComplete) return

    const config = data.getConfig()
    let isShippingAddressComplete: boolean = true
    const quoteDate = localStorage.getItem('quoteDate') || ''
    const quoteDetails: any = await request.api.getQuoteDetails(quoteId, {
      storeHash: (config?.storeProfile as any).storeHash,
      isBackendUser: '0',
      date: quoteDate
    })

    if (!quoteDetails?.shippingAddress?.countryCode) return

    const getAddressFields = data.getShippingAddressFields(quoteDetails?.shippingAddress?.countryCode)

    const dataConvert: any = {
      'firstName': 'firstName',
      'lastName': 'lastName',
      'company': 'company',
      'phone': 'phoneNumber',
      'address1': 'address',
      'address2': 'apartment',
      'city': 'city',
      'countryCode': 'countryCode',
      'stateOrProvince': 'state',
      'postalCode': 'zipCode',
    }
    isShippingAddressComplete = getAddressFields.every((item: any) => {
      const quoteName: any = dataConvert[item.name]
      if (item.custom) return true
      if (item.name !=='company') {
        if ((item.required && quoteDetails?.shippingAddress[quoteName]) || !item.required) return true
      }
      
      if (item.name ==='company') {
        if ((item.required && (quoteDetails?.companyInfo?.companyName || quoteDetails?.contactInfo?.name)) || !item.required) return true
      }

      return false
    })

    storage.B3QuoteLabel.setValue('')

    if (isShippingAddressComplete) {
      const basicAddressInfo = util.parseAddress({
        companyName: quoteDetails.companyInfo.companyName || quoteDetails.contactInfo.name,
        addressLine1: quoteDetails.shippingAddress.address || '',
        addressLine2: quoteDetails.shippingAddress.apartment || '',
        city: quoteDetails.shippingAddress.city || '',
        state: {
          stateCode: quoteDetails.shippingAddress.stateCode || '',
          stateName: quoteDetails.shippingAddress.state || '',
        },
        country: {
          countryName: quoteDetails.shippingAddress.country || '',
          countryCode: quoteDetails.shippingAddress.countryCode || '',
        },
        zipCode: quoteDetails.shippingAddress.zipCode || '',
        phoneNumber: quoteDetails.shippingAddress.phoneNumber || '',
        type: "residential",
        addressId: '',
        firstName: quoteDetails.shippingAddress.firstName || '',
        lastName: quoteDetails.shippingAddress.lastName || '',
        label: quoteDetails.shippingAddress.label || '',
        isShipping: 1,
        isBilling: 1,
        customFields: [],
      })
      const { global: { isB3User } } = store.getState()

      if (!isB3User) {
        const consignments = data.getConsignments() ?? []
        const cart = data.getCart()

        const promises: Array<Promise<CheckoutSelectors>> = []
        if (!consignments.length) {
          const physicalItems = cart?.lineItems.physicalItems ?? []
    
          const digitalItems = cart?.lineItems.digitalItems ?? []
          if (digitalItems.length && !physicalItems.length) return
    
          const defaultConsignment = physicalItems ? [{
            lineItems: physicalItems.map(({ id: itemId, quantity }) => ({
              itemId,
              quantity,
            })),
            shippingAddress: basicAddressInfo
          }] : []
          promises.push(service.createConsignments(defaultConsignment as ConsignmentsRequestBody))
          await Promise.all(promises)
        }
      } else {
        store.dispatch(setBasicAddressInfo(basicAddressInfo as CustomerAddress))
      }
      storage.B3QuoteLabel.setValue(basicAddressInfo?.label || '')
      storage.quoteShippingMethods.setValue(JSON.stringify(quoteDetails.shippingMethod))
    }
}


const init = async (data: CheckoutStoreSelector, service: CheckoutService) => {
  const customer = data.getCustomer()
  const config = data.getConfig()

  if (!customer || !customer.id) {
    await initStoreCheckoutSettings()
    store.dispatch(setGlobalIsPending(false))
    return
  }
  store.dispatch(setGlobalIsPending(true))
  try {
    if (!storage.B3RoleId.getValue()) await b3Login(customer.id, (config?.storeProfile as StoreProfile).storeHash)
  } catch (error) {
    console.error(error)
  }

  const { global: { isB3User } } = store.getState()


  if (isB3User) {
    await extrasFiles.getB3AddressFiles()
    await extrasFiles.getB3OrderFiles()
  } else {
    // solve b2b => bc  Flash display extras
    if (storage.B3OrderExtras.getValue()) storage.B3OrderExtras.removeValue()
    if (storage.B3DefaultAddressExtras.getValue()) {
      storage.B3BillingAddressExtras.removeValue()
      storage.B3ShippingAddressExtras.removeValue()
    }
  }

  await initStoreCheckoutSettings()

  // 判断quote 获取接口 bc 
  const quoteId = localStorage.getItem('quoteCheckoutId') || ''
  if (quoteId) {
    await getQuoteData(data, quoteId, service)
  }

  if (!isB3User) {
    store.dispatch(setGlobalIsPending(false))
    return
  };

  if (storage.B3RoleId.getValue() === constants.B3Role.SALESREP && !storage.B3CompanyStatus.getValue()) {
    await Swal.fire({
      icon: 'error',
      text: tips['b3.salesRep.notMasquerading'],
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
    location.href = routes.dashboard
    return Promise.reject()
  }

  try {
    await setBasicInfo(data)
    await addresses.init(data)

    await initDefaultShipping(data, service)
  } finally {
    store.dispatch(setGlobalIsPending(false))
  }
}

const setBasicInfo = async (data: CheckoutStoreSelector) => {
  const companyId = storage.B3CompanyId.getValue()

  const companyBasicInfo = await getCompanyBasicInfo(companyId)


  const {
    companyName,
    addressLine1,
    addressLine2,
    city,
    state,
    country,
    zipCode,
    phoneNumber,
  } = companyBasicInfo

  const customerAccountFields = data
    .getShippingAddressFields((country as Country).countryCode)
    .filter(field => field.custom)
    .reduce((result, { id, default: defaultValue, fieldType }) => {
      (result as any)[id] = B3SetField(defaultValue, fieldType)
      return result
    }, {})

  const basicAddressInfo = util.parseAddress({
    companyName,
    addressLine1,
    addressLine2,
    city,
    state,
    country,
    zipCode,
    phoneNumber,
    type: "residential",
    addressId: '',
    firstName: '',
    lastName: '',
    label: '',
    isShipping: 1,
    isBilling: 1,
    customFields: mapCustomFormFieldsFromFormValues(customerAccountFields),
  })

  store.dispatch(setCompanyBasicInfo(companyBasicInfo))
  const quoteId = localStorage.getItem('quoteCheckoutId') || ''
  if (!quoteId) {
    store.dispatch(setBasicAddressInfo(basicAddressInfo as CustomerAddress))
  }
}

const logout = () => {
  storage.clear()
  store.dispatch(setGlobalIsB3User(false))
}

const initDefaultShipping = async (data: CheckoutStoreSelector, service: CheckoutService) => {

  const { global: { checkoutShippingIsComplete } } = store.getState()
  if (checkoutShippingIsComplete) return

  const consignments = data.getConsignments() ?? []
  const cart = data.getCart()
  const getBillingAddress = data.getBillingAddress()

  const { company } = store.getState()
  const quoteId = localStorage.getItem('quoteCheckoutId') || ''

  if (!checkoutShippingIsComplete) {
    const {
      defaultShippingAddress,
      defaultBillingAddress,
      basicAddressInfo,
    } = company

    let defaultShipping, defaultBilling: any

    if (quoteId) {
      defaultShipping = basicAddressInfo
    } else {
      defaultShipping = defaultShippingAddress.address1 ? defaultShippingAddress : basicAddressInfo
      defaultBilling = defaultBillingAddress.address1 ? defaultBillingAddress : basicAddressInfo
    }

    const promises: Array<Promise<CheckoutSelectors>> = []

    if (!consignments.length) {
      const physicalItems = cart?.lineItems.physicalItems ?? []

      const digitalItems = cart?.lineItems.digitalItems ?? []
      if (digitalItems.length && !physicalItems.length) return

      const defaultConsignment = physicalItems ? [{
        lineItems: physicalItems.map(({ id: itemId, quantity }) => ({
          itemId,
          quantity,
        })),
        shippingAddress: address.convertAddress(defaultShipping)
      }] : []
      promises.push(service.createConsignments(defaultConsignment as ConsignmentsRequestBody))
    } else promises.push(service.updateShippingAddress(address.convertAddress(defaultShipping)))

    // !quoteId && promises.push(service.updateBillingAddress(address.convertAddress(defaultBilling)))
    if (JSON.stringify(getBillingAddress) === '{}') {
      const checkoutId = (window as any)?.checkoutConfig.checkoutId || ''
      const createBillAddress: any = () => axios({
        method: 'post',
        url: `/api/storefront/checkouts/${checkoutId}/billing-address`,
        data: {...address.convertAddress(defaultBilling)}
      })
      !quoteId && promises.push(createBillAddress())
    } else {
      !quoteId && promises.push(service.updateBillingAddress(address.convertAddress(defaultBilling)))
    }

    await Promise.all(promises)

    setAddressExtrasFiles(true, defaultShipping, true)
    defaultBilling && setAddressExtrasFiles(true, defaultBilling, false)
  }
}

// checkout config
export const initStoreCheckoutSettings = async () => {

  try {
    const { global: { isB3User } } = store.getState()

    let checkoutSettings: any = {}
    if (isB3User) {
      let storeCheckoutSettings = await getStoreCheckoutSettings()

      const {
        checkoutShippingAllowNewAddress,
        checkoutShippingAllowSaveAddress,
        checkoutShippingAllowSameAddress,
        checkoutBillingAllowNewAddress,
        checkoutBillingAllowSaveAddress,
      } = storeCheckoutSettings

      checkoutSettings = {
        'shipping.address.save': +checkoutShippingAllowSaveAddress.value === 1,
        'shipping.address.add': +checkoutShippingAllowNewAddress.value === 1,
        'shipping.singleAddress.allowAsBilling': +checkoutShippingAllowSameAddress.value === 1,
        'billing.address.add': +checkoutBillingAllowNewAddress.value === 1,
        'billing.address.save': +checkoutBillingAllowSaveAddress.value === 1,
        ...storeCheckoutSettings,
      }

    } else {
      checkoutSettings = {
        'shipping.address.save': permissions['address.save'],
        'billing.address.save': permissions['address.save'],
        ...permissions,
      }
    }

    store.dispatch(setCheckoutSettings(checkoutSettings))
  } catch (err) {
    console.log('InitStoreCheckoutSettingsError', err)
  }
}

const isShippingComplete = (steps: any) => {
  let isloading = true
  // isInvoice:  if invoice enter
  const isInvoice = steps.some((step: any) =>( step.type === "shipping" && step.isRequired))
  // Judge when shipping will be completed
  steps.map((step: any) => {
    if (isInvoice && step.type === "shipping" && !step.isComplete) {
      isloading =  false
    }

    if (!isInvoice && step.type === "billing" && !step.isComplete) {
      isloading =  false
    }
  })

  store.dispatch(setCheckoutShippingIsComplete(isloading))
}

export default {
  init,
  logout,
  isShippingComplete,
}
